export default {
  namespaced: 'bc500',
  state: {
    usableSetting: false
  },
  mutations: {
    disableSetting(state) {
      state.usableSetting = false;
    },
    enableSetting(state) {
      state.usableSetting = true;
    }
  }
};
